import { Component, OnInit } from '@angular/core';
import {HelperService} from '../../shared/services/helper.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MetaService} from '../../shared/services/meta.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-installments',
  templateUrl: './installments.component.html',
  styleUrls: ['./installments.component.scss']
})
export class InstallmentsComponent implements OnInit {

  constructor(private helperService: HelperService, private activatedRoute: ActivatedRoute, private meta: Meta, private metaService: MetaService) {
    helperService.setPageTitle(activatedRoute.snapshot.data.title);


  }

  ngOnInit(): void {
  	this.metaService.updateCanonicalURL();
  	let metaData: any = {
      title: this.activatedRoute.snapshot.data.breadcrumbs.title,
      description: this.activatedRoute.snapshot.data.breadcrumbs.description,
    };

    this.helperService.setCustomMeta(metaData);
  }

}
